import {z} from 'zod';

import i18n from '@dms/i18n';

export const carpassSettingsFormSchema = z.object({
  branchId: z.string().min(1, {message: i18n.t('general.validations.fieldIsRequired')}),
  username: z.string().min(1, {message: i18n.t('general.validations.fieldIsRequired')}),
  password: z
    .string()
    .trim()
    .min(1, {message: i18n.t('general.validations.fieldIsRequired')}),
  enteredOrganisation: z.string().min(1, {message: i18n.t('general.validations.fieldIsRequired')}),
  enterpriseOrganisation: z
    .string()
    .min(1, {message: i18n.t('general.validations.fieldIsRequired')}),
});
export type CarpassSettingsFormValues = z.infer<typeof carpassSettingsFormSchema>;
